import loadingImg from '../../assets/images/loading-green.svg';
import React, { Component } from 'react';
import './confirmacaoEmail.scss';



class ConfirmacaoEmail extends Component {


  componentDidMount() {
    let {
      match,
      history,
      checkConfirmationHashAction
    } = this.props;

    if (!match.params.id)
      history.push('/vamosComecar');
    else
      checkConfirmationHashAction(match.params.id);
      
    setTimeout(() => {
      window.localStorage.clear();
      window.location.href = "https://btcorretora.com.br/"
    }, 15000)
  }

  render() {
    let {
      match,
      setLoadingValue,
      confirmacaoEmail,
      checkConfirmationHashAction,
    } = this.props;

    let {
      loading,
      isError
    } = this.props.confirmacaoEmail;

    if (loading) {
      return (
        <div className="loadingScreen">
          <img className="loadingCircle" src={loadingImg} alt="loading" />
        </div>
      )
    }
    else {
      return (
        <div className="confirmacaoEmail">
          <div className="col">
            <i className={`successIcon fa ${this.props.confirmacaoEmail.screenInfo.icon}`}></i>
          </div>
          <div className="container">
            <div className="col">
              <h1 className="title">{this.props.confirmacaoEmail.screenInfo.title}</h1>
              <span className="message">{this.props.confirmacaoEmail.screenInfo.discription}</span>
            </div>
          </div>
        </div>)
    }
  }
}

export default ConfirmacaoEmail;